import { SecurityComponent } from "../../components/profile/security.component";

export const ProfilePage = () => {
  return (
    <>
      <div className="container">
        <h2 className="mt-5">Profile</h2>
        <SecurityComponent showSketchfabSrs={false} />
      </div>
    </>
  );
};
